import React from "react";
import './Portfolio.css';

import NavbarOne from "../../Pages/separate/NavbarOne";
import Footer from "../../Pages/separate/Footer";
import "../../assets/style.css";

const DepositCryptoDisable = (props) => {

    return (
        <section >
            <NavbarOne
                setTheme={props.setTheme}
                theme={props.theme}
            />
            {/* Disabled code */}
            <center className="min-vh-100 bg-default text-light pb-5 pt-3">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 mt-5">
                            <h1 className="visually-hidden">Crypto Deposit</h1>
                            <p className="fw-bold fs-5">Contact Support For Crypto Deposits</p>
                            <img src='/assets/service_un.png' alt="comming soon" className='img-fluid' width={500} />
                            <p className="fw-bold fs-5">Crypto Deposit</p>
                        </div>
                    </div>
                </div>
            </center>

            <Footer />
        </section>
    );
};

export default DepositCryptoDisable;